export default [
    // 6: 自信あり
    // 5: 得意
    // 4: 業務使いできる
    // 3: 普段使いできる
    // 2: 何かしら自分で作ってる
    // 1: かじったことある
    // 0: 自信なし
    {
      name:"C++", level:6
    },
    {
      name:"C", level:2
    },        
    {
      name:"C#", level:5
    },
    {
      name:"Objective-C", level:0
    },
    {
      name:"Java", level:3
    },
    {
      name:"JavaScript", level:3
    },
    {
      name:"PHP", level:4
    },
    {
      name:"Go", level:2
    },
    {
      name:"Python", level:0
    },    
    // {
    //   name:"Haskell", level:0
    // },      
    // {
    //   name:"Perl", level:0
    // }, 
    // {
    //   name:"Zephir", level:0
    // },        
    // {
    //   name:"MATLAB", level:0
    // },                  
    // {
    //   name:"Prolog", level:0
    // },
    {
      name:"HLSL", level:4
    },
    {
      name:"GLSL", level:2
    },     
    {
      name:"HTML", level:3
    },
    {
      name:"css", level:3
    },
    {
      name:"sass", level:3
    },
    {
      name:"SQL", level:4
    },             
    {
      name:"DirectX", level:2
    },
    {
      name:"Windows API", level:2
    },
    // {
    //   name:"OpenSiv3D", level:5
    // },             
    {
      name:"Siv3D", level:5
    },             
    {
      name:"Unreal Engine", level:1
    },   
    {
      name:"Unity", level:5
    },   
    {
      name:"cocos2d-x", level:1
    },      
    {
      name:"CocosCreater", level:1
    },
    {
      name:"Phalcon", level:0
    },
    // {
    //   name:"Laravel", level:0
    // },
    {
      name:"Vue.js", level:3
    },
    {
      name:"Capacitor", level:1
    },
    {
      name:"MySQL", level:3
    },
    {
      name:"SQLite", level:3
    },
    {
      name:"Redis", level:2
    },
    {
      name:"Docker", level:3
    },    
    // {
    //   name:"Vagrant", level:0
    // },             
    {
      name:"AWS", level:1
    },
    {
      name:"GitHub Actions", level:2
    },
    {
      name:"CircleCI", level:2
    },
    {
      name:"Git", level:5
    },
    {
      name:"SVN", level:1
    },
    {
      name:"Unity Version Control", level:1
    },
    {
      name:"Perforce", level:0
    },    
    {
      name:"Visual Studio", level:5
    },
    {
      name:"VS Code", level:3
    },
    {
      name:"IntelliJ", level:3
    },   
    {
      name:"Android Studio", level:2
    },
    {
      name:"XCode", level:1
    },  
    {
      name:"Windows", level:4
    },       
    {
      name:"Mac", level:2
    },            
    {
      name:"Linux", level:2
    },            
    {
      name:"Android", level:2
    },      
    {
      name:"iOS", level:1
    }, 
    {
      name:"Nintendo Switch", level:1
    },            
    {
      name:"Web", level:3
    },      
    // {
    //   name:"AR", level:0
    // }, 
    // {
    //   name:"Tobii EyeX", level:0
    // },       
    {
      name:"GitHub", level:4
    },
    {
      name:"Atlassian", level:3
    },   
    {
      name:"Google Workspace", level:3
    },        
    // {
    //   name:"Microsoft 365", level:3
    // },       
    {
      name:"Slack", level:3
    },       
    // {
    //   name:"Discord", level:2
    // },      
    // {
    //   name:"Notion", level:1
    // },       
    {
      name:"ChatGPT", level:3
    },     
  ];